<div class="row">
  <div class="col">
    <h3 class="main-title">Terms and conditions</h3>
  </div>
</div>

<div class="row">
  <div class="col">
    <p>To use our online booking service, first create an account using a valid email address.</p>
    <p>You are responsible for maintaining the confidentiality of your account, username and password and for
      restricting access to your computer.</p>
    <p>You agree to accept responsibility for all activities that occur under your account, username and/or
      password.
    </p>
    <p>You agree to provide only accurate, truthful information.</p>
    <p>We reserve the right to refuse service and/or terminate accounts without prior notice if you violate these
      terms and conditions or if we decide, in our sole discretion, that it would be in our clinic’s best
      interests to
      do so.</p>
    <h4 class="main-title">Use of Online Booking Service</h4>
    <p>You must be over 18 years of age and legally able to enter into a binding contract to use the Online
      Booking Service.</p>
    <p>You will be financially accountable for anyone using your password and login information, and may only use
      the Online Booking Service to make legitimate appointments.</p>
    <p>We will use our reasonable commercial efforts to keep the Online Booking Service available 24 hours a day,
      7 days a week, subject to necessary downtime for maintenance and system outages.</p>
    <p>We cannot guarantee uninterrupted access to our Online Booking Service at all times.</p>
    <p>We cannot promise that our Online Booking Service will be error-free, that defects or errors will be
      corrected or that our site and servers are free from viruses or other harmful components.</p>
    <p>You will not use any device, software or routine that interferes or attempts to interfere with the normal
      operation of this site or take any action that imposes an unreasonable load on our computer equipment.</p>
    <h4 class="main-title">Refund Policy</h4>
    <p>Your booking is refundable and transferable when more than 48 hours notice is given, by telephoning
      +61293022888.
    </p>
    <p>A 50% cancellation fee is applicable if less than 48 hours notice is given.</p>
    <h4 class="main-title">Forms of Payment</h4>
    <p>
      Universal Health accept payment by:<br />
      Visa Credit<br />
      Visa Debit<br />
      MasterCard Credit<br />
      MasterCard Debit<br />
      American Express <br />
    </p>
    <h4 class="main-title">No-Show Policy</h4>
    <p>
      If you are unable to attend an appointment, please provide at least 48 hours notice, or a 50% cancellation
      policy will apply.
    </p>
    <p>
      If you need to cancel your booking, please contact the clinic directly.
    </p>
    <h4 class="main-title">Our Company Details</h4>
    <p>
      Registered Office: Global Integrated Medicine Pty Ltd
    </p>
    <p>Level 4 377 New South Head Rd Double Bay NSW 2028 Australia</p>
    <h4 class="main-title">Customer Service Contact</h4>
    <p>
      If you have a question or complaint about Universal Health Services please contact
      reception@universalhealth.com.au
    </p>
    <p>
      +61293022888
    </p>
  </div>
</div>